export default __webpack_public_path__ + "media/images/favicon/web-app-manifest-512x512.png";